<template>
  <Card type="chart" :name="config.variableFullName">
    <template v-slot:header>
      <h5 v-if="!config.traceability" class="card-category pull-right">
        {{ getTimeAgo((nowTime - time) / 1000) }}
      </h5>

      <h5 class="card-category">
        {{ config.variableFullName }}
      </h5>

      <h3 class="card-title">
        <i
          class="fa"
          :class="[config.icon, getIconColorClass()]"
          aria-hidden="true"
          style="font-size: 30px; margin-right: 10px"
        >
        </i>
        <span v-if="!config.traceability"
          >{{ value.toFixed(config.decimalPlaces) }}
        </span>
        <span v-if="config.traceability">unidad : </span> {{ config.unit }}
      </h3>

      <div class="row" v-if="!config.demo">
        <div class="form-group col-sm-6 col-md-4 col-9">
          <div class="mb-0">
            <input
              v-if="!config.traceability"
              type="date"
              class="form-control"
              v-model="date_string"
              @change="updateChartData()"
            />
          </div>
        </div>
        <div class="col-md-4 col-sm-2 col-3">
          <button
            native-type="submit"
            type="info"
            class="btn btn-info btn-sm"
            size="sm"
            @click="generateExcel()"
          >
            Excel
          </button>
        </div>
      </div>
    </template>

    <div
      class="chart-area"
      :style="{ height: chartOptions.chart.height + 'px' }"
    >
      <highcharts
        style="height: 100%"
        v-if="isMounted"
        :options="chartOptions"
      />
    </div>
  </Card>
</template>

<script>
import XLSX from "xlsx";
import emitter from "@/eventBus";
import { mapState } from "vuex";
import axios from "@/axios";


export default {
  name: "rtnumberchart",
  props: ["config"],
  data() {
    return {
      date_string: "",
      receivedTime: 0,
      value: 0,
      time: Date.now(),
      nowTime: Date.now(),
      isMounted: false,
      topic: "",

      chartOptions: {
        accessibility: {
          enabled: false  // Deshabilitar el módulo de accesibilidad
        },        
        credits: {
          enabled: false,
        },
        chart: {
          renderTo: "container",
          defaultSeriesType: "line",
          backgroundColor: "rgba(0,0,0,0)",
          height: 400,
        },
        title: {
          text: "",
        },
        xAxis: {
          type: "datetime",
          labels: {
            style: {
              color: "#d4d2d2",
            },
          },
        },
        yAxis: {
          title: {
            text: "",
          },
          labels: {
            style: {
              color: "#d4d2d2",
              font: "11px Trebuchet MS, Verdana, sans-serif",
            },
          },
        },

        plotOptions: {
          series: {
            lineWidth: 1.5,
            label: {
              connectorAllowed: false,
            },
            pointStart: 2010,
          },
        },
        series: [
          {
            name: "",
            data: [],
            color: "#e14eca",
          },
        ],
        exporting: {
          enabled: false, // Habilita el exportador
          buttons: {
            contextButton: {
              menuItems: ['printChart']
            }
          }
        },
        legend: {
          itemStyle: {
            color: "#d4d2d2",
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 400,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      dark_mode: (state) => state.dashStyle.dark_mode,
    }),
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          this.value = 0;
          //this.$nuxt.$off(this.topic + "/sdata");
          emitter.off(this.topic + "/sdata");
          let variable = this.config.variable;
          if (this.$store.state.selectedDevice.ext_mqtt) {
            variable = this.config.variableFullName;
          }
          this.topic =
            this.config.userId +
            "/" +
            this.config.selectedDevice.dId +
            "/" +
            variable;

          if (!this.demo){
            emitter.on(this.topic + "/sdata", this.procesReceivedData);
        }

          this.chartOptions.series[0].data = [];

          this.getChartData();

          this.chartOptions.series[0].name =
            this.config.variableFullName + " " + this.config.unit;
          this.updateColorClass();
          window.dispatchEvent(new Event("resize"));
        }, 300);
      },
    },
    dark_mode: {
      immediate: true,
      handler(newVal) {
        this.chartOptions.xAxis.labels.style.color = newVal ? "#d4d2d2" : "#333333"
        this.chartOptions.yAxis.labels.style.color = newVal ? "#d4d2d2" : "#333333"
      },
    },
  },
  mounted() {
    window.innerHeight >= 1080
      ? (this.chartOptions.chart.height = 600)
      : (this.chartOptions.chart.height = 400);
    this.getNow();
    this.updateColorClass();
    this.getDateString();
  },
  beforeDestroy() {
    emitter.off(this.topic + "/sdata");
    // this.$nuxt.$off(this.topic + "/sdata");
  },
  methods: {
    generateExcel() {
      if (this.chartOptions.series[0].data.length === 0) {
        return;
      }

      const wb = XLSX.utils.book_new();

      const data = this.chartOptions.series[0].data.map((i) => {
        let date = i[0] + new Date().getTimezoneOffset() * 60 * 1000;
        date = new Date(date);


        const h = String(date.getHours()).padStart(2, "0");
        const m = String(date.getMinutes()).padStart(2, "0");

        return [
          `${h}:${m}`,
          Number(i[1].toFixed(this.config.decimalPlaces)),
          this.config.unit,
        ];
      });

      const ws_data = [
        ["CONTROL DE MEDICIONES"],
        [],
        [`Dispositivo: ${this.config.selectedDevice.name}`],
        [this.config.variableFullName],
        [],
        ["Fecha", this.date_string],
        [],
        ["Hora", "Valor", "Unidad"],
        ...data
      ];

      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      /* =======================
        MERGES (DISEÑO)
      ======================= */
      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 2 } }, // Título
        { s: { r: 2, c: 0 }, e: { r: 2, c: 2 } }, // Variable
        { s: { r: 3, c: 0 }, e: { r: 3, c: 2 } }, // Dispositivo
      ];

      /* =======================
        ANCHO DE COLUMNAS
      ======================= */
      ws["!cols"] = [
        { wch: 12 }, // Hora
        { wch: 14 }, // Valor
        { wch: 12 }  // Unidad
      ];

      /* =======================
        CONGELAR ENCABEZADO
      ======================= */
      ws["!freeze"] = { xSplit: 0, ySplit: 8 };

      /* =======================
        ESTILOS BÁSICOS
      ======================= */
      const bold = { font: { bold: true } };
      const center = { alignment: { horizontal: "center" } };

      ["A1", "A3", "A4"].forEach(cell => {
        if (ws[cell]) ws[cell].s = bold;
      });

      ["A1", "A3", "A4"].forEach(cell => {
        if (ws[cell]) ws[cell].s = { ...bold, ...center };
      });

      ["A8", "B8", "C8"].forEach(cell => {
        if (ws[cell]) ws[cell].s = bold;
      });

      /* =======================
        METADATOS
      ======================= */
      wb.Props = {
        Title: "SaveControl History",
        Subject: "Device Measurements",
        Author: "SaveControl",
        CreatedDate: new Date(),
      };

      XLSX.utils.book_append_sheet(wb, ws, "History Day");

      /* =======================
        NOMBRE DE ARCHIVO SEGURO
      ======================= */
      const clean = (s) =>
        s.replace(/[\\/:*?"<>|]/g, "-").substring(0, 50);

      const file_name = `${this.date_string}-${clean(this.config.selectedDevice.name)}-${clean(this.config.variableFullName)}.xlsx`;

      XLSX.writeFile(wb, file_name);
    }, // Cierre Generate Excel

    updateChartData() {
      this.getChartData();
      return;
    },

    getDateString() {
      let dateNow = new Date();
      let y = dateNow.getFullYear();
      let m = dateNow.getMonth() + 1;
      let d = dateNow.getDate();
      if (m < 10) {
        m = "0" + m;
      }
      if (d < 10) {
        d = "0" + d;
      }

      this.date_string = y + "-" + m + "-" + d;
      return;
    },

    updateColorClass() {
      //console.log("update" + this.config.class)

      var c = this.config.class;

      if (c == "success") {
        this.chartOptions.series[0].color = "#7cae47";
      }
      if (c == "primary") {
        this.chartOptions.series[0].color = "#4380dd";
      }
      if (c == "warning") {
        this.chartOptions.series[0].color = "#e69f17";
      }
      if (c == "danger") {
        this.chartOptions.series[0].color = "#e04f1a";
      }

      this.chartOptions.series[0].name =
        this.config.variableFullName + " " + this.config.unit;
    },

    getChartData() {
      if (this.config.demo) {
        this.chartOptions.series[0].data = [
          [1606659071668, 22],
          [1606659072668, 27],
          [1606659073668, 32],
          [1606659074668, 7],
        ];
        this.isMounted = true;
        return;
      }
      let url = "/get-small-charts-data";
      let dateString = this.date_string.replace(/-/g, "/");
      let axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      let variable = this.config.variable;
      if (this.$store.state.selectedDevice.ext_mqtt) {
        variable = this.config.variableFullName;
      }

      if (this.config.traceability) {
        axiosHeaders.params = {
          dId: this.config.selectedDevice.dId,
          variable,
          dateStart: this.config.dateStart,
          dateEnd: this.config.dateEnd,
        };
        url = "/get-data-range";
      } else {
        axiosHeaders.params = {
          dId: this.config.selectedDevice.dId,
          variable,
          chartTimeAgo: this.config.chartTimeAgo,
          chartDateNow: new Date(dateString).getTime(),
        };
      }

      axios
        .get(url, axiosHeaders)
        .then((res) => {
          if (res.status == 200) {
            this.chartOptions.series[0].data = [];
            const data = res.data.data;
            data.forEach((element) => {
              var aux = [];
              aux.push(
                element.time + new Date().getTimezoneOffset() * 60 * 1000 * -1
              );
              aux.push(element.value);
              this.chartOptions.series[0].data.push(aux);
            });

            this.isMounted = true;

            return;
          }

          console.log(res.status);
        })
        .catch((e) => {
          if (e.response == undefined){
            return
          }
          if (e.response.status == 400) {
            this.$notify({
              type: "warning",
              icon: "tim-icons icon-check-2",
              message: `Error en rango de fechas !`,
            });
            return;
          }
        });
    },

    getIconColorClass() {
      if (this.config.class == "success") {
        return "text-success";
      }
      if (this.config.class == "primary") {
        return "text-primary";
      }
      if (this.config.class == "warning") {
        return "text-warning";
      }
      if (this.config.class == "danger") {
        return "text-danger";
      }
    },

    procesReceivedData(data) {
      try {
        this.time = Date.now();
        this.value = data.value;

        setTimeout(() => {
          if (data.save == 1) {
            this.getChartData();
          }
        }, 1000);
      } catch (error) {
        console.log(error);
      }
    },

    getNow() {
      this.nowTime = Date.now();
      setTimeout(() => {
        this.getNow();
      }, 1000);
    },

    getTimeAgo(seconds) {
      if (seconds < 0) {
        seconds = 0;
      }

      if (seconds < 59) {
        return seconds.toFixed() + " secs";
      }

      if (seconds > 59 && seconds <= 3600) {
        seconds = seconds / 60;
        return seconds.toFixed() + " min";
      }

      if (seconds > 3600 && seconds <= 86400) {
        seconds = seconds / 3600;
        return seconds.toFixed() + " hour";
      }

      if (seconds > 86400) {
        seconds = seconds / 86400;
        return seconds.toFixed() + " day";
      }
    },
  },
};
</script>
<style></style>
